import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { textStyles } from './commons/textStyles';
export var Small = styled.small.withConfig({
  displayName: "Small",
  componentId: "sc-1e794gu-0"
})(["display:", ";", ";", ";"], function (_ref) {
  var display = _ref.display;
  return display ? display : 'inline-block';
}, getFont(-1, 'compact'), textStyles);